import React from 'react';
import { Section } from './ui/Section';
import { Lock, ShieldCheck, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <Section dark className="border-t-8 border-red-600 pb-24" data-id="element-26">
      <div className="max-w-3xl mx-auto text-center" data-id="element-27">
        <h2 className="text-4xl md:text-6xl font-bold mb-6 uppercase" data-id="element-28">
          Recupera el control de tu futuro
        </h2>
        <p className="text-xl text-gray-300 mb-12" data-id="element-29">
          Si estás cansado de sentirte un fracasado financiero, no necesitas
          otra idea. <br data-id="element-30" />
          <span className="text-white font-bold" data-id="element-31">
            Necesitas un sistema que te obligue a ejecutar aunque no tengas
            ganas.
          </span>
        </p>

        <div className="bg-white text-black p-8 md:p-12 shadow-[8px_8px_0px_0px_rgba(220,38,38,1)] transform hover:-translate-y-1 transition-transform duration-300" data-id="element-32">
          <div className="flex flex-col md:flex-row justify-between items-center border-b-2 border-gray-100 pb-8 mb-8" data-id="element-33">
            <div className="text-left" data-id="element-34">
              <h3 className="text-3xl font-bold uppercase" data-id="element-35">
                Protocolo Antipobreza™
              </h3>
              <div className="flex flex-col gap-1 mt-2 text-gray-600" data-id="element-36">
                <span className="flex items-center" data-id="element-37">
                  <ArrowRight className="w-4 h-4 mr-2" data-id="element-38" /> Acceso inmediato (PDF)
                </span>
                <span className="flex items-center" data-id="element-39">
                  <ArrowRight className="w-4 h-4 mr-2" data-id="element-40" /> Tablero Notion
                </span>
                <span className="flex items-center" data-id="element-41">
                  <ArrowRight className="w-4 h-4 mr-2" data-id="element-42" /> Scripts y plantillas
                </span>
              </div>
            </div>
            <div className="mt-6 md:mt-0 text-right" data-id="element-43">
              <p className="text-sm text-gray-500 uppercase tracking-widest mb-1" data-id="element-44">
                Precio Único
              </p>
              <p className="text-6xl font-black tracking-tighter" data-id="element-45">$9.99</p>
            </div>
          </div>

          <a href="https://glowliftessencemx.com/checkouts/cn/hWN7p0uqD5uNg58daDP06dxi/es-us?_r=AQABAEf7uOD-4Qp3sVkjC_dqmN7SeRIA3Kk7eavabZSDjF4&preview_theme_id=184489181460" className="w-full bg-red-600 text-white text-2xl font-bold uppercase py-5 hover:bg-red-700 transition-colors flex items-center justify-center gap-3" data-id="element-46">
            Comprar Ahora – $9.99
          </a>

          <div className="mt-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-47">
            <span className="flex items-center" data-id="element-48">
              <Lock className="w-4 h-4 mr-1" data-id="element-49" /> Pago seguro y encriptado
            </span>
            <span className="flex items-center" data-id="element-50">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-51" /> Garantía de satisfacción
            </span>
          </div>
        </div>

        <div className="mt-16 text-sm text-gray-500 space-y-4" data-id="element-52">
          <p className="max-w-2xl mx-auto border-t border-gray-800 pt-8" data-id="element-53">
            <strong data-id="element-54">IMPORTANTE:</strong> Este producto es informativo. No
            garantiza ingresos. Los resultados dependen de tu ejecución.
          </p>
          <p data-id="element-55">© 2026 Protocolo Antipobreza™. Todos los derechos reservados.</p>
        </div>
      </div>
    </Section>;
}